<script>
export default {
  name: "SNCRHeaderModal",
  emits: ['fechar'],
  methods: {
    closeModal() {
      this.$emit('fechar');
    }
  }
}
</script>

<template>
  <div style="width: 100%;" class="d-flex justify-content-between align-items-center">
    <div >
      <div class="d-flex align-items-center">
        <span class="badge badge-primary mr-2 title">
          SNCR
        </span>
        <h5 class="modal-title mb-0" id="sncrModalTitulo">Gestão de Numerações</h5>
      </div>
      <p class="text-muted small mb-0 mt-1" style="line-height: 1.3;">
        Sistema Nacional de Controle de Receituários
      </p>
    </div>
    <button
      type="button"
      class="close ml-3"
      aria-label="Fechar"
      @click="closeModal"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<style scoped>
.title {
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  padding: 0.35em 0.65em;
}
</style>